<template>
  <div>
    <div class="map" ref="google-map"></div>
  </div>
</template>
<script>
import gmapstyle from "@/config/gmapstyle";
import gmapstyleDarkTheme from "@/config/gmapstyle_dark_blue_theme";

export default {
  name: "basic-google-map",

  props: {
    markers: {
      type: [Array, Object],
      default() {
        return [] || {};
      },
    },

    darkTheme: {
      type: Boolean,
      default: false,
    },

    zoom: {
      type: Number,
      default: 16,
    },

    options: {
      type: Object,
      default() {
        return {
          disableDefaultUI: false,
          panControl: true,
        };
      },
    },
  },

  data() {
    return {
      map: null,
    };
  },

  mounted() {
    this.initMap();
  },

  methods: {
    initMap() {
      let mapElement = this.$refs["google-map"];

      this.map = new google.maps.Map(mapElement, {
        center: { lat: 0, lng: 0 },
        zoom: this.zoom,
        styles: this.darkTheme ? gmapstyleDarkTheme : gmapstyle,
        backgroundColor: "none",
        ...this.options,
      });

      this.renderMarkers();
    },

    renderMarkers() {
      let latLng = {
        lat: this.markers.latitude * 1,
        lng: this.markers.longitude * 1,
      };

      new google.maps.Marker({
        position: latLng,
        map: this.map,
        title: this.markers.name,
        icon: this.darkTheme
          ? require("@/assets/img/icon-location-blue.png")
          : require("@/assets/img/location@2x.png"),
      });

      this.map.setCenter(latLng);
    },
  },
};
</script>

<style lang="scss" scoped>
.map {
  width: 100%;
  height: 356px;
}
</style>
